import {
  FulfillmentsOverTimeRequestSchema,
  FulfillmentsOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getFulfillmentsOverTime = {
  name: "getFulfillmentsOverTime" as const,
  input: FulfillmentsOverTimeRequestSchema,
  output: FulfillmentsOverTimeResponseSchema,
};
